import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddFlatChargeTypeMutationVariables = Types.Exact<{
  input: Types.AddFlatChargeTypeInput;
}>;


export type AddFlatChargeTypeMutation = { __typename?: 'Mutation', addFlatChargeType: { __typename?: 'FlatChargeTypePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, flatChargeType?: { __typename?: 'FlatChargeTypeStateData', flatChargeTypeId: string } | null } };

export type UpdateFlatChargeTypeMutationVariables = Types.Exact<{
  input: Types.UpdateFlatChargeTypeInput;
}>;


export type UpdateFlatChargeTypeMutation = { __typename?: 'Mutation', updateFlatChargeType: { __typename?: 'FlatChargeTypePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, flatChargeType?: { __typename?: 'FlatChargeTypeStateData', flatChargeTypeId: string } | null } };

export type DeactivateFlatChargeTypeMutationVariables = Types.Exact<{
  input: Types.DeactivateFlatChargeTypeInput;
}>;


export type DeactivateFlatChargeTypeMutation = { __typename?: 'Mutation', deactivateFlatChargeType: { __typename?: 'FlatChargeTypePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, flatChargeType?: { __typename?: 'FlatChargeTypeStateData', flatChargeTypeId: string } | null } };

export type ReactivateFlatChargeTypeMutationVariables = Types.Exact<{
  input: Types.ReactivateFlatChargeTypeInput;
}>;


export type ReactivateFlatChargeTypeMutation = { __typename?: 'Mutation', reactivateFlatChargeType: { __typename?: 'FlatChargeTypePayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, flatChargeType?: { __typename?: 'FlatChargeTypeStateData', flatChargeTypeId: string } | null } };


export const AddFlatChargeTypeDocument = new TypedDocumentString(`
    mutation AddFlatChargeType($input: AddFlatChargeTypeInput!) {
  addFlatChargeType(input: $input) {
    errors {
      code
      message
    }
    flatChargeType {
      flatChargeTypeId
    }
  }
}
    `);
export const UpdateFlatChargeTypeDocument = new TypedDocumentString(`
    mutation UpdateFlatChargeType($input: UpdateFlatChargeTypeInput!) {
  updateFlatChargeType(input: $input) {
    errors {
      code
      message
    }
    flatChargeType {
      flatChargeTypeId
    }
  }
}
    `);
export const DeactivateFlatChargeTypeDocument = new TypedDocumentString(`
    mutation DeactivateFlatChargeType($input: DeactivateFlatChargeTypeInput!) {
  deactivateFlatChargeType(input: $input) {
    errors {
      code
      message
    }
    flatChargeType {
      flatChargeTypeId
    }
  }
}
    `);
export const ReactivateFlatChargeTypeDocument = new TypedDocumentString(`
    mutation ReactivateFlatChargeType($input: ReactivateFlatChargeTypeInput!) {
  reactivateFlatChargeType(input: $input) {
    errors {
      code
      message
    }
    flatChargeType {
      flatChargeTypeId
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddFlatChargeType: build.mutation<AddFlatChargeTypeMutation, AddFlatChargeTypeMutationVariables>({
      query: (variables) => ({ document: AddFlatChargeTypeDocument, variables })
    }),
    UpdateFlatChargeType: build.mutation<UpdateFlatChargeTypeMutation, UpdateFlatChargeTypeMutationVariables>({
      query: (variables) => ({ document: UpdateFlatChargeTypeDocument, variables })
    }),
    DeactivateFlatChargeType: build.mutation<DeactivateFlatChargeTypeMutation, DeactivateFlatChargeTypeMutationVariables>({
      query: (variables) => ({ document: DeactivateFlatChargeTypeDocument, variables })
    }),
    ReactivateFlatChargeType: build.mutation<ReactivateFlatChargeTypeMutation, ReactivateFlatChargeTypeMutationVariables>({
      query: (variables) => ({ document: ReactivateFlatChargeTypeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddFlatChargeTypeMutation, useUpdateFlatChargeTypeMutation, useDeactivateFlatChargeTypeMutation, useReactivateFlatChargeTypeMutation } = injectedRtkApi;
